import React, {useEffect,useState, useContext} from 'react';
import '../../../assets/css/views/recargas.css'
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import {primeraLetraMayuscula, formatState, soloDNI, soloCelular } from '../../../utils/utils';
import { useUsuariosPlataforma } from '../../../hooks/useUsuariosPlataforma';
import { Modal } from '../../components/modal/Modal';
import { useTipoUsuario } from '../../../hooks/useTipoUsuario';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { SearchTable } from '../../components/utils/SearchTable';
import { useRoles } from '../../../hooks/useRoles';
import { useUsuarios } from '../../../hooks/useUsuarios';
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';


export const UsuariosPlataforma = () => {
    const {
        usuarios,
        listarUsuarios,
        usuario,
        editarValorUsuario,
        obtenerUsuario,
        spinner,
        isOpen,
        closeModal,
        isOpenModalEliminar,
        closeModalEliminar,
        guardarEditarUsuario,
        eliminarUsuario,
        usuarioEliminar,
        cargarDatosPorDNI,
        spinnerBuscandoDNI
    } = useUsuariosPlataforma();

    const {
        listarUsuariosWeb
    } = useUsuarios()
    

    const { 
        roles
    } = useRoles()



    const [ verCombo, setVerCombo] = useState(true)
    const { listarTipoUsuarios, tipoUsuarios } = useTipoUsuario()
    const idTablaUsuarios = "tablaUsuarios"
    useEffect (()=>{
        listarTipoUsuarios()
    },[]) 

    const classNameInput = "text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    return (
        <>
            <ContenedorParametros
                titulo="Usuarios Web"
            >
                <div>
                    <BotonProcesar onClick={() => listarUsuarios()}></BotonProcesar>
                </div>
                <div>
                    <BotonNuevo onClick={() => {obtenerUsuario();setVerCombo(true)}}></BotonNuevo>
                </div>
                <SearchTable tablaId={idTablaUsuarios}></SearchTable>
            </ContenedorParametros>
                
            <ContenedorTabla>
                <table id={idTablaUsuarios} className="table">
                    <thead>
                        <tr>
                        <th className='w-[30px]'>N</th>
                        {/* <th className="w-[50px]">ID</th> */}
                            <th className='text-left'>NOMBRE</th>
                            <th className='text-left'>USUARIO</th>
                            <th className='text-left'>CORREO</th>        
                            <th className='text-left'>TIPO</th>
                            <th className='text-left'>ESTADO</th>
                            <th className='text-left'></th>
                            <th className='text-left'></th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                            usuarios.length > 0 
                            ? usuarios.map((u, i) => {
                                
                                return (
                                    <tr key={u.codUsuario}>
                                        <td>{++i}</td>
                                        {/* <td>{u.codUsuario}</td> */}
                                        <td className="text-left">{u.nomPersona}</td>
                                        <td className="text-left">{u.nomUsuario}</td>
                                        {/* <td className="text-left">{u.telefonoActual}</td> */}
                                        <td className="text-left">{u.correoActual}</td>
                                        <td className="text-left"><span className={`${formatState(1)}}`}>{u.nomUsuarioTipo}</span></td>
                                        <td className='text-left'><span className={`${formatState(u.codEstado===1? 4 : 7) }`} >{primeraLetraMayuscula(u.nomEstado)}</span></td>
                                        <td className="text-left">
                                            <button onClick={() =>{ obtenerUsuario(u.nomUsuario); setVerCombo(false) }} className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded">
                                                <i className='fas fa-edit'></i>
                                            </button>
                                        </td>
                                        <td>
                                        { u.codEstado!==5 &&
                                            <button className="bg-red-500 hover:bg-red-600 text-[14px] px-[5px] py-1 rounded">
                                                <i
                                                    className='fas fa-trash'
                                                    // onClick={()=> usuarioEliminar(u.codUsuario)}
                                                ></i>
                                            </button>
                                        }
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        
                    </tbody>
                </table>
            </ContenedorTabla>

            <Modal 
                isOpen={isOpen} closeModal={closeModal} action={guardarEditarUsuario}
                title="Registrar nuevo usuario"
                spinner={spinner}
            >
                <div className="w-full px-10 justify-center grid grid-cols-[minmax(0,25fr)_minmax(0,75fr)] gap-y-2">
                    <label>Documento:</label>
                    <select //select ruta 
                        className={`${classNameInput} containerScroll`} 
                        value={usuario.rol} 
                        onChange={(e) => editarValorUsuario("rol",e.target.value)}>
                        <option value={0}> DNI </option>
                    </select>
                    <label>Número: </label>
                    <div className="flex items-center gap-4 w-[250px]">
                        <input autoFocus={true} className={`${classNameInput} caret-input`} value={  usuario.dni} onChange={(e) => {editarValorUsuario("dni", e.target.value)}} onKeyPress={(e) => soloDNI(e, e.target)} />
                        <button onClick={()=>cargarDatosPorDNI()} className={`${spinnerBuscandoDNI? 'fa fa-spinner animate-spin' : 'fa fa-search'} hover:text-blue-500`}></button>
                    </div>
                    <label>Nombres:</label>
                    <input className={`${classNameInput} caret-input`} autoComplete='false' value={usuario.nombre} onChange={(e) => editarValorUsuario("nombre", e.target.value)} />
                    <label>Apellidos:</label>
                    <input className={`${classNameInput} caret-input`} autoComplete='false' value={usuario.apellidos} onChange={(e) => editarValorUsuario("apellidos", e.target.value)} />
                    <label>Email:</label>
                    <input className={`${classNameInput} caret-input`} autoComplete='false' value={usuario.correoElectronico} onChange={(e) => editarValorUsuario("correoElectronico", e.target.value)} />
                    <label>Telefono:</label>
                    <input className={`${classNameInput} caret-input`} autoComplete='false' value={usuario.telefono} onChange={(e) => editarValorUsuario("telefono", e.target.value)} onKeyPress={(e) => soloCelular(e, e.target)} />
                    <label>Roles:</label>
                    <select //select ruta 
                        className={`${classNameInput} containerScroll`} 
                        value={usuario.rol} 
                        onChange={(e) => editarValorUsuario("rol",Number(e.target.value))}>
                        <option value={0}>-- Todos --</option>
                        {
                            roles?.map((r)=>{
                                return <option key={r.codRol} value={r.codRol}>{r.nomRol}</option>
                            })
                        }
                    </select>
                    <label>Nombre Usuario:</label>
                    <input className={`${classNameInput} caret-input`} autoComplete='false' value={usuario.nombreUsuario} onChange={(e) => editarValorUsuario("nombreUsuario", e.target.value)} />
                    <label>Clave</label>
                    <input type={'password'} className={`${classNameInput} caret-input`} autoComplete='false' value={usuario.clave} onChange={(e) => editarValorUsuario("clave", e.target.value)} />
                </div>
            </Modal>

            <Modal 
                isOpen={isOpenModalEliminar} closeModal={closeModalEliminar} action={() => eliminarUsuario()}
                title= "¿Seguro que desea eliminar a este Usuario?"
                spinner={spinner}
                textButtons={{ confirm: 'Si', denied: 'No' }}
            >
                    <div className="flex gap-8 items-center flex-wrap justify-center">
                        <div className="w-[400px] px-4">
                            <label className="text-center gap-8">Ingrese Comentario de Eliminación </label>
                            <div className="flex items-center gap-4 w-[280px]">
                                <input autoFocus={true} className={`${classNameInput} caret-input`} defaultValue={usuario.motivoEliminacion} onChange={(e) => editarValorUsuario("motivoEliminacion", e.target.value)}/>
                            </div>
                        </div>
                    </div>
            </Modal>   
        </>
    )
}